import React, { useContext } from 'react';
import { Button } from 'antd';

import ActivityEditDialog from '@totem/components/ticketing/details/activities/activityEditDialog';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { ActivityCreateExtras } from '@totem/components/ticketing/types';
import { isNotNull, isNull } from '@totem/utilities/common';

type Props = {
  extras?: ActivityCreateExtras;
  title: string;
  activityId: string;
  buttonProps?: Omit<
    React.ComponentProps<typeof Button>,
    'onClick' | 'disabled' | 'children'
  >;
};

const ButtonCreateStaticActivity = ({
  extras,
  activityId,
  title,
  buttonProps,
}: Props) => {
  const { onAction, activityConfiguration, action, actionExtras } =
    useContext(TicketContext);

  let dialogExtras = extras;
  if (isNull(dialogExtras)) {
    dialogExtras = { activityId };
  } else {
    dialogExtras.activityId = activityId;
  }

  const hasPermissions = () => {
    const activityConfig = activityConfiguration.find(
      (activity) => activity.id === activityId,
    );

    return isNotNull(activityConfig);
  };

  const isMatchingActivity = () => {
    if (isNotNull(actionExtras)) {
      try {
        const foundExtras: ActivityCreateExtras = JSON.parse(actionExtras);
        if (foundExtras.activityId !== null) {
          if (activityId === foundExtras.activityId) {
            return true;
          }
        }
      } catch {
        /* empty */
      }
    }
    return false;
  };

  return (
    <>
      {hasPermissions() && (
        <>
          <Button
            type="primary"
            {...(buttonProps as object)}
            disabled={!hasPermissions()}
            onClick={() =>
              onAction(
                'show-static-activity-dialog',
                dialogExtras !== null ? JSON.stringify(dialogExtras) : '',
              )
            }
          >
            {title}
          </Button>
          {action === 'show-static-activity-dialog' && isMatchingActivity() && (
            <ActivityEditDialog staticActivityCode={activityId} />
          )}
        </>
      )}
    </>
  );
};

export default ButtonCreateStaticActivity;
